<template>
    <div class="vx-col w-full mb-base m-auto">
        <vx-card>
            <vs-tabs>
                <vs-tab label="Manage Vehicles">
                    <!-- Add vehicle form -->
                    <form class="w-full mt-2 mb-2" v-show="vehicleAddEdit" autocomplete="off" data-vv-scope="vehicle-form">
                        <div class="vx-row mb-2">
                            <h4 class="ml-5 mb-5"><strong>{{ vehicleIndex ? 'Edit' : 'Add' }} Vehicle</strong></h4>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col md:w-1/4 form-group w-full">
                                <vs-select autocomplete class="w-full" v-validate="'required'" label="Office" name="office_id" v-model="office_id">
                                    <vs-select-item :key="index" :value="item.id" :text="item.office_name" v-for="(item,index) in offices" />
                                </vs-select>
                                <span class="text-danger text-sm">{{ errors.first('vehicle-form.office_id') }}</span>
                            </div>

                            <!--  <div class="vx-col md:w-1/4 form-group w-full" v-show="status_arr.length != 0">
                                <vs-select
                                autocomplete
                                class="w-full"
                                v-validate="'required'"
                            label="Status"
                                name="status"
                                v-model="status"
                                :disabled="!vehicleIndex"
                                >
                                <vs-select-item
                                    :key="index"
                                    :value="item.value"
                                    :text="item.name"
                                    v-for="(item,index) in status_arr"
                                />
                                </vs-select>
                                <span class="text-danger text-sm">{{ errors.first('vehicle-form.status') }}</span>
                            </div>-->
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col md:w-1/4 form-group w-full">
                                <vs-input class="w-full" label="Make" v-validate="'required|max:25'" name="name" v-model="name" autocomplete="off" />
                                <span class="text-danger text-sm">{{ errors.first('vehicle-form.name') }}</span>
                            </div>
                            <div class="vx-col md:w-1/4 form-group w-full">
                                <vs-input class="w-full" label="Model" v-validate="'required|max:25'" name="brand" v-model="brand" autocomplete="off" />
                                <span class="text-danger text-sm">{{ errors.first('vehicle-form.brand') }}</span>
                            </div>
                            <div class="vx-col md:w-1/6 form-group">
                                <vs-input type="number" class="w-full" label="Year" v-validate="'required|max:4|between:2000,'+currentYear" name="vehicle_year" v-model="year" autocomplete="off" @keydown="filterKey" />
                                <span class="text-danger text-sm">{{ errors.first('vehicle-form.vehicle_year') }}</span>
                            </div>
                            <div class="vx-col md:w-1/6 form-group">
                                <vs-select autocomplete class="w-full" label="Type" name="type" v-model="type">
                                    <vs-select-item :key="index" :value="item.value" :text="item.name" v-for="(item,index) in types" />
                                </vs-select>
                                <span class="text-danger text-sm">{{ errors.first('vehicle-form.type') }}</span>
                            </div>
                            <div class="vx-col md:w-1/6 form-group">
                                <vs-input class="w-full" label="Colour" v-validate="'max:25|alpha_spaces'" name="colour" v-model="colour" autocomplete="off" />
                                <span class="text-danger text-sm">{{ errors.first('vehicle-form.colour') }}</span>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/4 form-group w-full">
                                <vs-input class="w-full" label="Registration #" v-validate="'required|max:10|alpha_num'" name="rego_number" v-model="vehicle_number" autocomplete="off" />
                                <span class="text-danger text-sm">{{ errors.first('vehicle-form.rego_number') }}</span>
                            </div>

                            <div class="vx-col md:w-1/4 form-group w-full">
                                <label for class="vs-input--label">Rego Due Date</label>
                                <datepicker class="w-full calendar-icon-right" label="Rego Due Date" :calendar-button="true" calendar-button-icon="fa fa-calendar" v-validate="''" name="rego_next_date" v-model="rego_next_date" format="dd-MM-yyyy" autocomplete="off" :disabledDates="disabledPastDates"></datepicker>
                                <span class="text-danger text-sm">{{ errors.first('vehicle-form.rego_next_date') }}</span>
                            </div>
                            <div class="vx-col md:w-1/4 form-group w-full">
                                <vs-input class="w-full" label="Vehicle ID" v-validate="(v_id_type=='type')?'required|max:5|alpha_num':''" name="vehicle_id" v-model="vehicle_id" autocomplete="off" :disabled="is_disabled" />
                                <span class="text-danger text-sm">{{ errors.first('vehicle-form.vehicle_id') }}</span>
                            </div>
                            <div class="vx-col md:w-1/4 form-group w-full mt-3" v-if="show_v_type == true">
                                <!-- <div class="vx-row"> -->
                                    <!-- <div class="vx-col md:w-1/2 form-group w-full"> -->
                                        <vs-radio v-model="v_id_type" vs-value="auto">Auto Generate</vs-radio>
                                    <!-- </div>
                                    <div class="vx-col md:w-1/2 form-group w-full"> -->
                                        <vs-radio v-model="v_id_type" vs-value="type">Type</vs-radio>
                                    <!-- </div>
                                </div> -->
                            </div>
                        </div>
                        <!-- <div class="vx-row mt-2 mb-2">
                            <div class="vx-col w-full">
                                <h4 class="">Service Due</h4>
                                <p class="">
                                    <strong>Notes :</strong> To notify management when the services are due for this vehicle please select the <br> Service Schedule as per the vehicle Manufacturers requirements(choose: miles/km’s or by due date).
                                </p>
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full mb-5">
                                <div class="w-full float-left">
                                    <div class="vx-col">
                                        <vs-radio class="radio mt-8" ref="serviceDueKm" v-model="serviceDue" name="serviceDue" vs-value="kmmiles"></vs-radio>
                                    </div>
                                    <div class="vx-col">
                                        <span class="mr-4 mt-8 float-left">Every</span>
                                    </div>
                                    <div class="vx-col">
                                        <vs-input label type="number" class="mt-6 md:w-1/6 float-left" v-validate="'required_if:serviceDueKm,kmmiles|decimal:2|max:8'" name="starting_kms" v-model="service_due_date.kmmiles" autocomplete="off" :disabled="serviceDue !== 'kmmiles'" />
                                    </div>
                                    <div class="vx-col">
                                        <span class="ml-4 mt-8 float-left">KMs/Miles</span>
                                    </div>
                                </div>
                                <span class="text-danger text-sm">{{ errors.first('vehicle-form.starting_kms') }}</span>
                            </div>

                            <div class="vx-row ml-1">
                                <div class="vx-col padr0 mt-3">
                                    <vs-radio v-model="serviceDue" ref="serviceDueDate" name="serviceDue" vs-value="sevice_date"></vs-radio>
                                </div>
                                <div class="vx-col pad0 mt-3 ml-3 ipad-100">
                                    <span class>1st service due Date</span>
                                </div>
                                <div class="vx-col padr0">
                                    <datepicker class="" label="Service Due Date" v-validate="'required_if:serviceDueDate,sevice_date'" format="dd-MM-yyyy" name="service_due_date" v-model="service_due_date.date" autocomplete="off" :disabledDates="disabledPastDates" :disabled="serviceDue !== 'sevice_date'"></datepicker>
                                    <span class="text-danger text-sm float-left">{{ errors.first('vehicle-form.service_due_date') }}</span>
                                </div>

                                <div class="vx-col padr0 mt-3 ipad-100">
                                    <span class="mt-8">Then Every</span>
                                </div>
                                <div class="vx-col padr0">
                                    <vs-input label type="number" class @keydown="filterKey" v-validate="'required_if:serviceDueDate,sevice_date|max_value:12|max:2'" name="month" v-model="service_due_date.month" autocomplete="off" :disabled="serviceDue !== 'sevice_date'" />
                                    <span class="text-danger text-sm float-left">{{ errors.first('vehicle-form.month') }}</span>
                                </div>
                                <div class="vx-col padr0 mt-3">
                                    <span class="mt-8">Months thereafter</span>
                                </div>
                            </div>
                        </div> -->
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full mt-5 mb-5">
                                <vs-button class="mt-1 m-auto gradient-btn" @click.prevent="addUpdateVehicle()" :disabled="button_loading" id="vehicle-addupdate">{{ vehicleIndex ? 'Save' : 'Add' }}</vs-button>
                                <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelAddEdit()">Cancel</vs-button>
                            </div>
                        </div>
                        <hr>
                    </form>
                    <!-- Add vehicle form -->
                    <div>
                        <!-- Select office / add vehicle button / Vehicle Table -->
                        <div class="selectAll all-vehical">
                            <div class="">
                                <vs-select autocomplete v-validate="''" label="Select Office" name="filter_office_id" v-model="filter_office_id" @change="changeOffice()">
                                    <vs-select-item value="all" text="All" />
                                    <vs-select-item :key="index" :value="item.id" :text="item.office_name" v-for="(item,index) in offices" />
                                </vs-select>
                            </div>
                            <div class="float-right" v-if="!vehicleAddEdit">
                              
                                <div class="mb-2 ">
                                    <vs-button
                                        type="filled"
                                        class="mr-1 float-left download-btn gradient-btn"
                                        icon-pack="feather"
                                        icon="icon-download"
                                        title="Sample CSV"
                                        @click.stop="downloadSampleCSV()"
                                    ></vs-button>
                                    <vs-button class="ml-2 m-auto gradient-btn" @click="importVehiclePopup =! importVehiclePopup">Import</vs-button>
                                    <vs-button class="ml-2 m-auto gradient-btn" @click="exportCSV()">Export</vs-button>
                                </div>
                                
                            </div>
                        </div>
                        <div class="tab-text">
                            <div class="mt-2 mb-5  word-custom">
                                <vs-table :data="vehicles" pagination max-items="10" class="mt-2 mb-5">
                                    <template slot="thead">
                                        <vs-th sort-key="vehical_id" >ID</vs-th>
                                        <vs-th sort-key="name" >Vehicle</vs-th>
                                        <vs-th sort-key="number" >Registration #</vs-th>
                                        <vs-th sort-key="office_id.office_name" >Office</vs-th>
                                        <vs-th sort-key="status" >Status</vs-th>
                                        <vs-th>Action</vs-th>
                                    </template>
                                    <template slot-scope="{data}">
                                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                            <vs-td :data="tr.vehical_id">{{(tr.vehical_id)?tr.vehical_id:""}}</vs-td>
                                            <!--<vs-td>
                                                <img class="size" :src="require(`@/assets/images/pages/car.png`)" />
                                            </vs-td>-->
                                            <vs-td :data="tr.name+' '+tr.brand">{{ tr.name }} {{ tr.brand }}</vs-td>
                                            <vs-td :data="tr.number">{{ tr.number }}</vs-td>
                                            <!-- <vs-td>N/A</vs-td> -->
                                            <vs-td :data="tr.office_id.office_name">{{ tr.office_id.office_name}}</vs-td>
                                            <vs-td :data="findStatus(tr.status)">
                                                <span>{{ findStatus(tr.status)}}</span>
                                            </vs-td>
                                            <vs-td>
                                                <vs-button color="#4285f4" type="filled" class="mr-2 mb-2 edit-user float-left view-btn" icon-pack="feather" icon="icon-eye" size="small" title="View Vehicle" @click.stop="viewVehicleDetails(data[indextr])"></vs-button>
                                                <vs-button color="#F4B400" type="filled" class="mr-2 mb-2 edit-user float-left" icon-pack="feather" icon="icon-edit-2" size="small" title="Edit Vehicle" v-if="$store.state.uInfo.role !== 'U'" @click.stop="editVehicle(data[indextr])"></vs-button>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </div>
                        <!-- Select office / add vehicle button / Vehicle Table -->
                     </div>
                </vs-tab>
                <vs-tab label="Book Vehicle">
                    <booked-vehicle ></booked-vehicle>
                </vs-tab>
                
            </vs-tabs>
            <div class="mb-2 text-right vehical-custom">
                <vs-button class="m-auto gradient-btn ml-0" v-if="$store.state.uInfo.role !== 'U'" @click.prevent="vehicleAddEdit = true">Add Vehicle</vs-button> 
            </div>
            
        </vx-card>
        <vs-popup
        class="holamundo view_vehicle"
        title="Vehicle Details"
        :active.sync="vehicleDetailPopup"
        >
            <vs-tabs>
                <vs-tab label="Vehicle Details">
                <div class="overflow-auto mb-5">
                    <table class="mt-2 mt-xl-0 w-full">
                        <tr>
                            <th class="pb-50 bg-grey-light">Vehicle</th>
                            <td class="pb-50">{{vehicleViewData.name}} {{vehicleViewData.brand}}</td>
                        </tr>
                        <tr>
                            <th class="pb-50 bg-grey-light">Type</th>
                            <td class="pb-50">{{ vehicleViewData.type }}</td>
                        </tr>
                        <tr>
                            <th class="pb-50 bg-grey-light">Colour</th>
                            <td class="pb-50">{{ vehicleViewData.colour }}</td>
                        </tr>
                        <tr>
                            <th class="pb-50 bg-grey-light">Rego Number</th>
                            <td class="pb-50">{{ vehicleViewData.number }}</td>
                        </tr>
                         <tr>
                            <th class="pb-50 bg-grey-light">Current KM’s/Miles</th>
                            <td class="pb-50">
                                <span v-if="vehicleViewData.service_due_date">{{ vehicleViewData.service_due_date.kmmiles }}</span> KMs/Miles
                            </td>
                        </tr>
                        <tr>
                            <th class="pb-50 bg-grey-light">Vehicle ID #</th>
                            <td class="pb-50">{{ (vehicleViewData.vehical_id)?vehicleViewData.vehical_id:"" }}</td>
                        </tr>
                        <tr>
                            <th class="pb-50 bg-grey-light">Year</th>
                            <td class="pb-50">{{ vehicleViewData.year }}</td>
                        </tr>
                        <tr>
                            <th class="pb-50 bg-grey-light">Office</th>
                            <td class="pb-50">{{ vehicleViewData.office_id ? vehicleViewData.office_id.office_name : 'N/A' }}</td>
                        </tr>
                        <tr>
                            <th class="pb-50 bg-grey-light">Status</th>
                            <td class="pb-50">
                            <span v-if="vehicleViewData.status === 'AV'">Available</span>
                            <span v-else-if="vehicleViewData.status === 'BD'">Break Down</span>
                            <span v-else-if="vehicleViewData.status === 'IU'">In Use</span>
                            <span v-else-if="vehicleViewData.status === 'BO'">Booked</span>
                            <span v-else></span>
                            </td>
                        </tr>
                        <tr>
                            <th class="pb-50 bg-grey-light">Rego Due</th>
                            <td class="pb-50">{{ vehicleViewData.rego_next_date | moment('timezone',$store.state.uInfo.timeZone, 'DD-MM-YY') }}</td>
                        </tr>
                        <tr>
                            <th class="pb-50 bg-grey-light">Next Service Due</th>
                            <td
                            v-if="vehicleViewData.service_due_date"
                            >{{ vehicleViewData.service_due_date.date | moment('timezone',$store.state.uInfo.timeZone, 'DD-MM-YY') }}</td>
                        </tr>
                        <tr v-if="vehicleViewData.qr_code">
                            <th class="pb-50 bg-grey-light">QR Code</th>
                            <td class="pb-50">
                                <img
                                    :src="vehicleViewData.qr_code"
                                    class="code-border"
                                    alt
                                />
                                <vs-button
                                    color="primary"
                                    class="hover-class"
                                    type="filled"
                                    icon-pack="feather"
                                    icon="icon-download"
                                    @click="qrcodePrint(vehicleViewData.qr_code,'V')"
                                >Download</vs-button>
                            </td>
                        </tr>
                    </table>
                </div>
                </vs-tab>
                <vs-tab label="Fuel Receipts">
                <div class="tab-text">
                    <div class="mt-5 mb-5">
                        <div class="vx-row mb-5" v-if="vehicleViewData">
                            <div class="vx-col md:w-1/3 justify-center">
                                <span class="text-center">
                                    <strong>Vehicle:</strong> {{vehicleViewData.name}} {{vehicleViewData.brand}}
                                </span>
                            </div>
                            <div class="vx-col md:w-1/3 justify-center">
                                <span class="text-center">
                                    <strong>Registration:</strong> {{vehicleViewData.number}}
                                </span>
                            </div>
                        </div>
                        <div class="vx-row mb-5 align-items-center justify-content-between">
                            <div class="vx-col md:w-1/4 justify-center">
                                <span class="text-center">Year to date Totals for:</span>
                            </div>
                            <!-- Total Receipt History -->
                            <div class="vx-col md:w-1/5 justify-center">
                                <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                                    <div class="ml-3 text-center">
                                        <h3 class="mb-1 font-bold">{{ receipts.totalReceiptHistory ? receipts.totalReceiptHistory : 0}}</h3>
                                        <span>Receipts</span>
                                    </div>
                                    <feather-icon icon="TrendingUpIcon" class="p-3 inline-flex rounded-full text-primary" :style="{background: `rgba(var(--vs-primary),.10)`}"></feather-icon>
                                </div>
                            </div>
                            <!-- Total Volume History -->
                            <div class="vx-col md:w-1/5 justify-center">
                                <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                                    <div class="ml-3 text-center">
                                        <h3 class="mb-1 font-bold">{{ receipts.totalVolumeHistory ? receipts.totalVolumeHistory : 0}}</h3>
                                        <span>Volumes</span>
                                    </div>
                                    <feather-icon icon="BoxIcon" class="p-3 inline-flex rounded-full text-danger" :style="{background: `rgba(var(--vs-danger),.10)`}"></feather-icon>
                                </div>
                            </div>
                            <!-- Total Amount History -->
                            <div class="vx-col md:w-1/5 justify-center">
                                <div class="pb-0 flex justify-between flex-row-reverse items-center float-left">
                                    <div class="ml-3 text-center">
                                        <h3 class="mb-1 font-bold">${{ receipts.totalAmountHistory ? receipts.totalAmountHistory : 0}}</h3>
                                        <span>Amount</span>
                                    </div>
                                    <feather-icon icon="DollarSignIcon" class="p-3 inline-flex rounded-full text-success" :style="{background: `rgba(var(--vs-success),.10)`}"></feather-icon>
                                </div>
                            </div>
                        </div>
                        <vs-table :data="receipts.findFuelReceipts" :pagination="receipts.findFuelReceipts.length != 0" max-items="10">
                            <template slot="thead">
                                <!-- <vs-th> </vs-th> -->
                                <vs-th sort-key="createdAt" >Date</vs-th>
                                <vs-th sort-key="receipt_no" >Odometer</vs-th>
                                <vs-th sort-key="createdAt" >Time</vs-th>
                                <vs-th sort-key="amount" >Amount</vs-th>
                                <vs-th sort-key="quantity" >Quantity</vs-th>
                                <vs-th sort-key="user_id" >Filled By</vs-th>
                                <vs-th>Image</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                                    <!-- <vs-td>
                                        <img class="size" :src="require(`@/assets/images/pages/car.png`)" />
                                    </vs-td> -->
                                    <vs-td :data="tr.createdAt | moment('timezone',$store.state.uInfo.timeZone,'DD/MM/YY')"> 
                                        {{ tr.createdAt | moment('timezone',$store.state.uInfo.timeZone, 'DD/MM/YY') }}
                                    </vs-td>
                                    <vs-td :data="tr.receipt_no">{{ tr.receipt_no }}</vs-td>
                                    <vs-td :data="tr.createdAt | moment('timezone',$store.state.uInfo.timeZone, 'h:m a')">
                                        {{ tr.createdAt | moment('timezone',$store.state.uInfo.timeZone, 'h:m a') }}
                                    </vs-td>
                                    <vs-td :data="tr.amount">{{ tr.amount | amount}}</vs-td>
                                    <vs-td :data="tr.quantity">{{ tr.quantity}}</vs-td>
                                    <vs-td :data="tr.user_id.firstname+' '+tr.user_id.lastname">
                                        {{ tr.user_id.firstname+" "+tr.user_id.lastname }}
                                    </vs-td>
                                    <vs-td>
                                        <a :href="tr.receipt_image ? tr.receipt_image : require(`@/assets/images/pages/no-receipt.png`)" target="_blank">
                                                                    <img
                                                                    class="rsize"
                                                                    :src="tr.receipt_image ? tr.receipt_image : require(`@/assets/images/pages/no-receipt.png`)"
                                                                    />
                                                                </a>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>
                </vs-tab>
            </vs-tabs>
        </vs-popup>
        <!-- vehicle import popup -->
        <vs-popup class="holamundo" title="Import User Details" :active.sync="importVehiclePopup">
            <form class="w-full" autocomplete="off" data-vv-scope="import-form">
                <div class="vx-row mb-2">
                    <div class="vx-col md:w-1/1 form-group w-full mb-5">
                        <select
                            class="new_select con-select w-full vs-select--label"
                            name="importOffice"
                            placeholder="Office"
                            v-model="importOffice"
                            v-validate="'required'"
                            >
                        <option :value="null" disabled hidden>Select Office</option>
                        <option
                            v-for="(o,index) in offices"
                            :key="index"
                            :value="o.id"
                        >{{ o.office_name }}</option>
                        </select>
                        <span
                        v-show="errors.has('import-form.importOffice')"
                        class="text-danger text-sm"
                        >{{ errors.first('import-form.importOffice') }}</span>
                    </div>
                    <div class="vx-col md:w-1/1 form-group w-full">
                        <input
                        type="file"
                        id="file"
                        name="importFile"
                        class="vs-inputx vs-input--input normal hasValue"
                        accept=".csv"
                        v-validate="'required'"
                        ref="file"
                        v-on:change.prevent="handleFileUpload()"
                        />
                        <span  v-show="errors.has('import-form.importFile')" class="text-danger text-sm" >{{ errors.first('import-form.importFile') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full">
                        <vs-button
                        class="mt-5 m-auto"
                        @click.prevent="importVehicle()"
                        :disabled="button_loading"
                        id="import"
                        >Import</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup>
    </div>
</template>

<script>
import { Validator } from "vee-validate";
import timeZone from "@/mixins/timezone.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import BookedVehicle from "@/components/vehicle/book-vehicle.vue";

Validator.extend("verify_csv", {
    //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
    validate: value => {
        var strongRegex = new RegExp(
            "([a-zA-Z0-9\s_\\.\-:])+(.csv|.CSV)$"
        );
        return strongRegex.test(value);
    }
});

//Validator.updateDictionary(dictionary);

const dict = {
    custom: {
        vehicle_id: {
            required: "Please enter vehicle-ID",
            max: "Vehicle ID should not be greater than 5 characters",
            alpha_num: "Only alphanumeric value is allowed"
        },
        office_id: {
            required: "Please select office"
        },
        dept_id: {
            required: "Please select department"
        },
        name: {
            required: "Please enter name",
            max: "Vehicle make should not be greater than 25 characters",
            alpha_num: "Only alphanumeric value is allowed"
        },
        rego_number: {
            required: "Please enter rego number",
            max: "Rego number should not be greater than 10 characters",
            alpha_num: "Only alphanumeric value is allowed"
        },
        starting_kms: {
            required_if: "Please enter starting kms",
            decimal: "Starting Kms should be numeric and may contain 2 decimal points",
            max: "Starting Kms should not be greater than 8 digits"
        },
        from_date: {
            required: "Please select start date"
        },
        start_time: {
            required: "Please select start time"
        },
        end_date: {
            required: "Please select end date"
        },
        end_time: {
            required: "Please select end time"
        },
        vehicle_year: {
            required: "Please enter vehicle year",
            max: "Vehicle year should not be greater than 4 digits",
            alpha_num: "Only alphanumeric value is allowed",
            between: "Year must be between 2000-" + new Date().getFullYear()
        },
        type: {
            max: "type name should not be greater than 25 characters",
            alpha_num: "Only alphanumeric value is allowed"
        },
        colour: {
            max: "colour name should not be greater than 25 characters",
            alpha_num: "Only alphanumeric value is allowed"
        },
        brand: {
            required: "Please enter Model",
            max: "Vehicle model should not be greater than 25 characters",
            alpha_num: "Only alphanumeric value is allowed"
        },
        service_due_date: {
            required_if: "Please select service due date"
        },
        month: {
            required_if: "Please enter month",
            max_value: "Month value can not be greater than 12",
            max: "Month should not be greater than 2 characters"
        },
        importFile: {
            required: "Please select csv file",
            verify_csv: "Please select valid csv file"
        }
    }
};
// register custom messages
Validator.localize("en", dict);

export default {
    components: {
        Datepicker,
        BookedVehicle
    },
    data() {
        return {
            show_v_type: true,
            vehicle_id: "",
            is_disabled: false,
            v_id_type: "type",
            serviceDue: "kmmiles",
            receipts: {
                totalReceiptHistory: 0,
                totalVolumeHistory: 0,
                totalAmountHistory: 0,
                findFuelReceipts: [], // fuel receipts array
            },
            vehicles: [],
            booked: [],
            currentYear: new Date().getFullYear(),
            offices: [],
            deleteIndex: 0,
            vehicleAddEdit: false,

            vehicleIndex: null,
            vehicle_name: null,
            office_id: null,
            rego_next_date: null,
            starting_kms: null,
            vehicle_number: null,
            service_due_date: null,
            vehicleDetailPopup: false,
            vehicleViewData: [],
            status: "AV",
            name: null,
            tabvalue: 0,
            brand: null,
            dept_id: null,
            departments: [],
            vehicleID: null,
            year: null,
            type: null,
            colour: null,
            service_due_date: {
                kmmiles: null,
                date: null,
                month: null
            },
            disabledPastDates: {
                to: new Date(Date.now() - 8640000)
            },
            configdateTimePicker: {
                enableTime: true,
                enableSeconds: false,
                noCalendar: true,
                dateFormat: "G:i K"
            },
            configFromdateTimePicker: {
                minDate: new Date(),
                maxDate: null,
                dateFormat: "d/m/Y"
            },
            configTodateTimePicker: {
                minDate: null,
                dateFormat: "d/m/Y"
            },
            month: null,
            filter_office_id: "all",
            start_time: null,
            from_date: null,
            end_time: null,
            end_date: null,
            status_arr: [{
                    value: "AV",
                    name: "Available"
                },
                {
                    value: "BD",
                    name: "Break Down"
                }
            ],
            types: [
                { value: "Sedan", name: "Sedan" },
                { value: "Pickup", name: "Pickup" },
                { value: "Wagon", name: "Wagon" },
                { value: "Ute", name: "Ute" },
                { value: "Van", name: "Van" }
            ],
            //==================
            importVehiclePopup: false,
            importOffice: null,
            importFile: null
        };
    },
    created() {
        // if (
        //   this.$store.state.uInfo.role !== "CA" &&
        //   this.$store.state.uInfo.role !== "HR"
        // ) {
        //   history.back();
        // }
    },
    mounted() {
        this.getOffice();
        this.getVechicle();
    },
    computed: {
        email_validate() {
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(this.email);
        },
        check_start_end_time() {
            let start_t = this.start_time;
            let start_d = this.from_date;
            let end_d = this.end_date;
            let end_t = this.end_time;
        }
    },
    watch: {
        serviceDue(nv) {
            if (nv == "kmmiles") {
                this.service_due_date.date = null;
                this.service_due_date.month = null;
            } else {
                this.service_due_date.kmmiles = null;
            }
        },
        v_id_type(val) {
            if (val == "auto") {
                this.is_disabled = true;
                this.generateVid();
            } else {
                this.is_disabled = false;
                this.vehicle_id = "";
            }
        }
    },

    methods: {
        // find & return status value 
        findStatus(status){
            if (status == 'AV') {
                return 'Available';
            }
            else if (status == 'BD') {
                return 'Break Down';
            }
            else if (status == 'IU') {
                return 'In Use';
            }
            if (status == 'BO') {
                return 'Nooked';
            }
            else{
                return '-';
            }
        },
        // ===== Download Sample User CSV  =====
        downloadSampleCSV() {
            let url = "/vehical/exportCsvForVehical";
            this.axios
            .get(url)
            .then(response => {
                var url = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Vehicle-Sample-CSV.csv");
                document.body.appendChild(link);
                link.click();
            })
            .catch(e => {
                this.showError(e);
            });
        },
        //Get imported csv file upload
        handleFileUpload() {
            let importFile = this.$refs.file.files[0];
            if (!importFile && !importFile.type && importFile.type != 'text/csv') {
                this.$vs.notify({
                    text: 'Please select valid csv file',
                    color: "danger",
                    position: "top-right"
                });
                return
            }
            this.importFile = importFile;
        },
        // Import vehicle details
        importVehicle() {
            this.$validator.validateAll("import-form").then(result => {
                if (result) {
                    this.$vs.loading({ color: "primary" });
                    let formData = new FormData();
                    formData.append("file", this.importFile);
                    formData.append("office", this.importOffice);
                    this.axios
                    .post("vehical/importVehicle", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(response => {
                        
                        this.$validator.reset("import-form");
                        this.errors.clear("import-form");
                        document.getElementById("file").value = "";
                        this.importFile = null;
                        this.importOffice = null;
                        this.importVehiclePopup = false;
                        let text = "CSV import successfully!!!";
                        this.$vs.notify({
                            text: text,
                            color: "success",
                            position: "top-right"
                        });
                        this.$vs.loading.close();
                        this.getVechicle();
                    })
                    .catch(e => {
                        //this.button_loader(false, "#import");
                        this.showError(e, "#import");
                    });
                }
            });
        },
        // ===== Export User CSV =====
        exportCSV() {
            let url = "vehical/getVehicleCsv";
            this.axios
                .get(url)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "Vehicle.csv");
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(e => {
                    this.showError(e);
                });
        },
        generateVid() {
            var length = 5;

            var text = "";
            var possible = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            for (var i = 0; i < length; i++) {
                text += possible.charAt(Math.floor(Math.random() * possible.length));
            }
            this.vehicle_id = text;
        },
        endTimeCheck() {
            let start = moment(this.start_time, ["h:mm A"]).format("HH:mm");
            let end = moment(this.end_time, ["h:mm A"]).format("HH:mm");
            if (end < start) {
                this.$vs.notify({
                    text: "End time should exceed the start time",
                    position: "top-right",
                    color: "danger"
                });
                return false;
            } else if (end == start) {
                this.$vs.notify({
                    text: "Start time and end time cannot be same",
                    position: "top-right",
                    color: "danger"
                });
                return false;
            }
        },
        changeOffice() {
            if (this.filter_office_id == "all") {
                this.getVechicle();
            } else {
                this.$vs.loading({ color: "primary" });
                let url = "vehicals?office_id=" + this.filter_office_id;
                this.axios
                    .get(url)
                    .then(response => {
                        let data = response.data.data;
                        this.vehicles = data;
                        this.$vs.loading.close();
                    })
                    .catch(e => {
                        this.showError(e);
                    });
            }
        },
        viewVehicleDetails(vehicle) {
            let url = "vehical?id=" + vehicle.id;
            this.axios
                .get(url)
                .then(response => {
                    this.vehicleViewData = response.data.data;
                    this.vehicleDetailPopup = true;
                })
                .catch(e => {
                    this.showError(e);
                });

            let vurl = "fuel?vehical_id=" + vehicle.id;
            this.axios
                .get(vurl)
                .then(response => {
                    let data = response.data.data;
                    if (data) {
                        this.receipts = data;
                    }
                })
                .catch(e => {
                    this.showError(e);
                });
        },

        // ===== Confirm Delete =====
        confirmBook(id) {
            this.vehicleID = id;
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure you want to book this vehicle?",
                acceptText: "Book",
                accept: this.bookVehicle
            });
        },

        getOffice() {
            this.$vs.loading({ color: "primary" });

            let url = "office/getAll";
            this.axios
                .get(url)
                .then(response => {
                    let data = response.data.data;
                    this.offices = data;
                    this.$vs.loading.close();
                })
                .catch(e => {
                    this.showError(e);
                });
        },
        getVechicle() {
            this.$vs.loading({ color: "primary" });

            let url = "vehicals";
            this.axios
                .get(url)
                .then(response => {
                    let data = response.data.data;
                    this.vehicles = data;
                    this.$vs.loading.close();
                })
                .catch(e => {
                    this.showError(e);
                });
        },

        editVehicle(vehicle) {
            this.vehicle_id = vehicle.vehical_id ? vehicle.vehical_id : null;
            this.is_disabled = vehicle.vehical_id ? true : false;
            this.show_v_type = vehicle.vehical_id ? false : true;
            this.vehicleAddEdit = true;
            this.vehicleIndex = vehicle.id;
            this.office_id = vehicle.office_id.id;
            this.name = vehicle.name;
            this.brand = vehicle.brand;
            this.starting_kms = vehicle.starting_km;
            this.vehicle_number = vehicle.number;
            this.year = vehicle.year;
            this.type = vehicle.type;
            this.colour = vehicle.colour;
            this.service_due_date = vehicle.service_due_date;
            this.rego_next_date = vehicle.rego_next_date;
            this.status = vehicle.status;
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        viewVehicle(vehicle) {
            this.vehicle_id = vehicle.vehical_id;
            this.vehicleAddEdit = true;
            this.vehicleIndex = vehicle.id;
            this.office_id = vehicle.office_id.id;
            this.name = vehicle.name;
            this.brand = vehicle.brand;
            this.starting_kms = vehicle.starting_km;
            this.vehicle_number = vehicle.number;
            this.year = vehicle.year;
            this.type = vehicle.type;
            this.colour = vehicle.colour;
            this.service_due_date = vehicle.service_due_date;
            this.rego_next_date = vehicle.rego_next_date;
            this.status = vehicle.status;
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        addUpdateVehicle() {
            this.$validator.validateAll("vehicle-form").then(result => {
                if (result) {
                    this.button_loader(true, "#vehicle-addupdate");

                    if (this.vehicleIndex) {
                        this.updateVehicle();
                    } else {
                        this.addVehicle();
                    }
                }
            });
        },
        addVehicle() {
            let input = {
                vehical_id: this.vehicle_id,
                office_id: this.office_id,
                name: this.name,
                brand: this.brand,
                year: this.year,
                type: this.type,
                colour: this.colour,
                service_due_date: this.service_due_date,
                starting_km: this.service_due_date.kmmiles,
                number: this.vehicle_number.toUpperCase(),
                rego_next_date: this.rego_next_date,
                status: this.status
            };
            this.axios
                .post("vehicals", input)
                .then(response => {
                    this.button_loader(false, "#vehicle-addupdate");
                    let text = "Vehicle created successfully!!!";
                    this.$vs.notify({
                        text: text,
                        color: "success",
                        position: "top-right"
                    });
                    this.vehicleAddEdit = false;
                    this.office_id = null;
                    this.name = null;
                    this.brand = null;
                    this.starting_kms = null;
                    this.vehicle_number = null;
                    this.service_due_date = {
                        kmmiles: null,
                        date: null,
                        month: null
                    };
                    //  this.service_due_date = null;
                    this.rego_next_date = null;
                    this.getVechicle();
                    this.tabvalue = 0;
                })
                .catch(e => {
                    this.showError(e, "#vehicle-addupdate");
                });
        },
        updateVehicle() {
            let input = {
                vehical_id: this.vehicle_id,
                id: this.vehicleIndex,
                office_id: this.office_id,
                name: this.name,
                brand: this.brand,
                year: this.year,
                type: this.type,
                colour: this.colour,
                starting_km: this.service_due_date.kmmiles,
                number: this.vehicle_number.toUpperCase(),
                service_due_date: this.service_due_date,
                rego_next_date: this.rego_next_date
            };
            this.axios
                .put("vehicals", input)
                .then(response => {
                    this.button_loader(false, "#vehicle-addupdate");
                    let text = "Vehicle updated successfully!!!";
                    this.$vs.notify({
                        text: text,
                        color: "success",
                        position: "top-right"
                    });
                    this.vehicleAddEdit = false;
                    this.office_id = null;
                    this.name = null;
                    this.brand = null;
                    this.starting_kms = null;
                    this.vehicle_number = null;
                    this.service_due_date = {
                        kmmiles: null,
                        date: null,
                        month: null
                    };
                    this.vehicleIndex = null;
                    this.rego_next_date = null;
                    this.getVechicle();
                    this.tabvalue = 0;
                })
                .catch(e => {
                    this.showError(e, "#vehicle-addupdate");
                });
        },
        cancelAddEdit() {
            this.vehicleAddEdit = false;
            this.vehicleIndex = null;
            this.office_id = null;
            this.vehicle_id = null;
            this.name = null;
            this.brand = null;
            this.starting_kms = null;
            this.vehicle_number = null;
            this.year = null;
            this.type = null;
            this.colour = null;
            this.service_due_date = {
                kmmiles: null,
                date: null,
                month: null
            };
            this.v_id_type = 'type';
            this.show_v_type = true;
            this.$validator.reset();
            this.errors.clear();
            this.rego_next_date = null;
            this.getVechicle();
            this.tabvalue = 0;
        }
    }
};
</script>

<style>
.code-border {
    border: 1px solid;
}

.minus-top {
    margin-top: -58px;
}

.selectAll .input-select-con {
    margin-bottom: 15px;
}

.size {
    height: 25px;
}

.rsize {
    height: 50px;
    width: 60px;
}

.vehicle-type .vx-col {
    padding: 0 0rem;
}

.radio {
    width: auto !important;
}

.pad0 {
    padding: 0 !important;
}

.padr0 {
    padding-right: 0 !important;
}

.r_align {
    align-items: baseline !important;
}

.new_select {
  background: #fff !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  height: 43.59px !important;
  border-radius: 5px !important;
  padding: 0.7rem;
  font-size: 1rem;
}
</style>

		